import * as React from 'react';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import { AdminGeneralInfoResult } from '../../../../models/adminGeneral';
import { formatRubles } from '../../../../common/money';
import { Delta } from '../Delta';

export type ProfitCardProps = { data: AdminGeneralInfoResult | null };

export const ProfitCard: React.FC<ProfitCardProps> = React.memo(({ data }) => {
    return (
        <Sheet variant="outlined" sx={{ p: 2, borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <TrendingUpRoundedIcon fontSize="small" />
                <Typography level="title-md">Профит</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, rowGap: 0.25, flexWrap: 'wrap' }}>
                    <Tooltip title="Профит за выбранный (прошлый) периоды" disablePortal={false}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', columnGap: 1 }}>
                            <PaidRoundedIcon
                                fontSize="small"
                                sx={{ color: (data && data.profitSum > data.profitSumLastPeriod) ? 'success.600' : 'danger.600' }}
                            />
                            <Typography level="title-lg" sx={{ color: (data && data.profitSum > data.profitSumLastPeriod) ? 'success.600' : 'danger.600' }}>
                                {data ? `+${formatRubles(data.profitSum)}` : '-'}
                            </Typography>
                            <Typography level="body-sm" sx={{ color: 'neutral.500' }}>
                                {data ? `(+${formatRubles(data.profitSumLastPeriod)})` : ''}
                            </Typography>
                        </Box>
                    </Tooltip>
                    {data ? (
                        <Tooltip title="Прирост относительно прошлого месяца" disablePortal={false}>
                            <Box sx={{ ml: 0.5 }}>
                                <Delta current={data.profitSum} previous={data.profitSumLastPeriod} />
                            </Box>
                        </Tooltip>
                    ) : null}
                </Box>
                <Box>
                    <Typography level="body-sm">В день</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, rowGap: 0.25, flexWrap: 'wrap' }}>
                        <Tooltip title="Средний профит в день этого (прошлого) периодов" disablePortal={false}>
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', columnGap: 1 }}>
                                <Typography level="title-lg" sx={{ color: (data && data.profitInDaySum > data.profitInDaySumLastPeriod) ? 'success.600' : 'danger.600' }}>
                                    {data ? `+${formatRubles(data.profitInDaySum)}` : '-'}
                                </Typography>
                                <Typography level="body-sm" sx={{ color: 'neutral.500' }}>
                                    {data ? `(+${formatRubles(data.profitInDaySumLastPeriod)})` : ''}
                                </Typography>
                            </Box>
                        </Tooltip>
                        {data ? (
                            <Tooltip title="Прирост относительно прошлого месяца" disablePortal={false}>
                                <Box sx={{ ml: 0.5 }}>
                                    <Delta current={data.profitInDaySum} previous={data.profitInDaySumLastPeriod} />
                                </Box>
                            </Tooltip>
                        ) : null}
                    </Box>
                </Box>
            </Box>
        </Sheet>
    );
});

ProfitCard.displayName = 'ProfitCard';


